import { render, staticRenderFns } from "./variant-qr-list.vue?vue&type=template&id=c67f10b2&scoped=true"
import script from "./variant-qr-list.vue?vue&type=script&lang=js"
export * from "./variant-qr-list.vue?vue&type=script&lang=js"
import style0 from "./variant-qr-list.vue?vue&type=style&index=0&id=c67f10b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67f10b2",
  null
  
)

export default component.exports